
import { getValueWithoutSymbol, convertCurrency, getFormCampaign } from "../helpers";
import { OtherAmountInput } from "./otherAmountInput";
import { DonationForm } from "../donation/donationForm";

export class PledgeRadio {
    donationForm;
    handlesContainer;
    otherAmountInput;
    amountRadios;
    optionsValues = [];
    elementValueIndex;
    labelSelector;
    storageKey;
    currencyCode;
    baseCurrencyCode;
    //callbacks
    onAmountSelected;
    
  constructor(donationForm, otherAmountInput, elMap = {handlesContainerSelector: "#amount-container", amountRadioNames: "Unchained-Singapore",
        elementValueIndex: 2, labelSelector: ".radio_dark.w-form-label"}, currencyCode = "SGD") {
      this.donationForm = donationForm instanceof DonationForm ? donationForm : null;
      this.handlesContainer = this.donationForm.form.querySelectorAll(elMap.handlesContainerSelector)[0];
      this.otherAmountInput = otherAmountInput && otherAmountInput instanceof OtherAmountInput? otherAmountInput : undefined;
      this.amountRadios = this.donationForm.form.querySelectorAll(`input[name="${elMap.amountRadioNames}"]`); 
      this.elementValueIndex = elMap.elementValueIndex;
      
      this.labelSelector = elMap.labelSelector;
      this.storageKey = getFormCampaign(FCBH.GIVE_FORM).localForm;
      this.currencyCode = currencyCode;
      this.baseCurrencyCode = donationForm.defaultCurrency;
      this.createCallbacks();
  }

  createCallbacks() {
    
    this.amountRadios.forEach(radio => {
        //write pledge message
        //load radios listeners
        let pledgeEl = radio.parentElement.querySelector(this.labelSelector);
        let value = radio.value.split("-");
        let pledgeText = value.length > 1 ? value[1] : "";
        let newAmount = String(value[0]).replaceAll(',', '');
        let content = getValueWithoutSymbol(newAmount, this.currencyCode);
        
        if (!isNaN(content) ) {
            this.optionsValues.push(content);
           // content = currency(this.currencyCode)+content;
           this.generateAmountLabel(radio.id, pledgeEl, this.currencyCode, content, pledgeText);
        } else {
            pledgeEl.innerHTML = pledgeEl.innerHTML;
          }


        radio.addEventListener('click', async ({ target }) => {
            let value = target.value.split("-");
            let pledgeText = value.length > 1 ? value[1] : "";
            this.donationForm.saveFormInStorage("pledge_message", pledgeText);
            let newAmount = String(value[0]).replaceAll(',', '');
            let toCurrency = FCBH.getFromStorage( this.storageKey)?.currency_code ?? this.currencyCode;
            let content = getValueWithoutSymbol(newAmount, toCurrency);
            this.currencyCode = toCurrency;
        
            if (isNaN(content) && this.otherAmountInput){
                this.donationForm.donationType = 'donate';
                pledgeText = "";
                 const usdAmount = toCurrency === 'USD'?this.otherAmountInput.initialValue: await convertCurrency(toCurrency, "USD", this.otherAmountInput.initialValue);
                
                this.otherAmountInput.otherContainer.style.display = 'block'; 
                this.otherAmountInput.otherContainer.style.opacity= '100'; 

                this.otherAmountInput.otherInput.value = this.otherAmountInput.initialValue;
                this.otherAmountInput.otherInput.dispatchEvent(new Event("change"));
                this.onAmountSelected(this.otherAmountInput.otherInput.value, usdAmount);
            } else {
                this.donationForm.donationType = 'pledge';
                const usdAmount = toCurrency === 'USD'? content : await convertCurrency(toCurrency, "USD", content);
                if (this.otherAmountInput) this.otherAmountInput.otherContainer.style.display = 'none';
                this.onAmountSelected(content, usdAmount);            
            }
            FCBH.saveToStorage(this.storageKey, {
                ...FCBH.getFromStorage( this.storageKey),
                "pledge_message": pledgeText
            });
        });
    });

    if (this.otherAmountInput) {
        this.otherAmountInput.otherContainer.style.display = 'none'; 
        this.otherAmountInput.otherContainer.style.opacity= '0'; 
    }

  }

  generateAmountLabel(fromRadioId, pledgeEl, currencyCode, amount, text){ 
      var value = getValueWithoutSymbol(amount, currencyCode);
      var result = `${currency(currencyCode)} ${parseFloat(value).toLocaleString('us-US',{minimumFractionDigits: 2, maximumFractionDigits: 2})} ${text}`;
      pledgeEl.innerHTML = result;
  }

  changeAmountClass(radios){
      radios.forEach(optionNode => {
        const element = optionNode.parentNode.children[this.elementValueIndex];
      });
  }
}
const currency = (currencyCode) => {
    return currencyCode === 'USD' ? "$" : currencyCode + " ";
}